import * as _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { DefaultBranchKpi, IBranch, IBranchKpi, IKpi } from 'src/Definitions';
import { BranchKpiDto, Client, IBranchKpiDto, SwaggerResponse } from 'src/generated_client';
import NotificationStore from '../NotificationStore';

export default class BranchKpisStore {
    @observable
    public isLoading: boolean = false;
    @observable
    public isModalOpen: boolean;
    @observable
    public branchKpis: IBranchKpi[];
    @observable
    public branches: IBranch[];
    @observable
    public kpis: IKpi[];

    constructor(private client: Client, private notificationStore: NotificationStore) {}

    @action.bound
    public closeDialog() {
        this.branches = [];
        this.kpis = [];
        this.branchKpis = [];
        this.isModalOpen = false;
    }

    @action.bound
    public getBranchKpis(branchId: string, pageNumber?: number, pageSize?: number): Promise<void> {
        if (!pageNumber) {
            pageNumber = 1;
        }
        if (!pageSize) {
            pageSize = 25;
        }
        this.isLoading = true;
        return this.client
            .getAllBranchKpis(branchId, undefined, pageNumber, pageSize)
            .then((resp: SwaggerResponse<IBranchKpiDto[]>) =>
                runInAction(() => {
                    if (this.branchKpis) {
                        this.branchKpis = this.branchKpis.concat(this.setupBranchKpis(resp.result));
                    } else {
                        this.branchKpis = this.setupBranchKpis(resp.result);
                    }
                })
            )
            .catch(() => {})
            .finally(() => {
                runInAction(() => {
                    this.isLoading = false;
                });
            });
    }

    @action.bound
    public getAllBranchKpis() {
        this.isLoading = true;
        if (this.branches) {
            this.branches.forEach((branch) => {
                this.getBranchKpis(branch.id, undefined, 5000);
            });
        }
    }

    @action.bound
    public getBranchListKpis(targetBranchId: string, branchIds?: string[]): Promise<void[]> {
        this.isLoading = true;
        if (branchIds) {
            branchIds.unshift(targetBranchId);
        } else {
            branchIds = [targetBranchId];
        }
        const responses = [];
        for (const branchId of branchIds) {
            responses.push(this.getBranchKpis(branchId));
        }
        return Promise.all(responses);
    }

    @action.bound
    public openBranchKpiDialog(targetBranch: IBranch, branches: IBranch[], kpis: IKpi[]) {
        this.branches = branches;
        this.branches.unshift(targetBranch);
        this.kpis = kpis;
        this.branchKpis = [];
        this.isModalOpen = true;
        this.getAllBranchKpis();
    }

    @action.bound
    public recoverBranchKpi(branchId: string, branchKpi: IBranchKpi) {
        this.isLoading = true;
        return this.client
            .reactivateBranchKpi(branchId, branchKpi.id)
            .then()
            .catch(() => {})
            .finally(() => {
                runInAction(() => {
                    this.isLoading = false;
                });
            });
    }

    @action.bound
    public saveBranchKpi(branchId: string, branchKpi: IBranchKpi) {
        this.isLoading = true;
        let promise;
        const branchKpiDto = new BranchKpiDto(branchKpi);
        if (branchKpi.isNew) {
            promise = this.client.createBranchKpi(branchId, branchKpiDto);
        } else {
            promise = this.client.updateBranchKpi(branchKpi.id, branchId, branchKpiDto);
        }
        return promise
            .then(() => {
                runInAction(() => {
                    this.notificationStore.sendNotification(
                        '200',
                        'Branch Comparisons have been saved.'
                    );
                });
            })
            .catch(() => {})
            .finally(() =>
                runInAction(() => {
                    this.isLoading = false;
                })
            );
    }

    private setupBranchKpis = (branchKpis: IBranchKpiDto[]) => {
        return branchKpis.map((x) => this.addDefaultFields(x));
    };

    private addDefaultFields = (branchKpi: IBranchKpiDto): IBranchKpi => {
        return { ...DefaultBranchKpi(), ...branchKpi };
    };
}



// WEBPACK FOOTER //
// ./src/stores/BranchKpisStore/BranchKpisStore.ts